// 基础数据块 - 避免重复定义
const ID_CARD_REQUIREMENT = {
  title: "身份证人像面照片<br/>身份证国徽面照片",
  des: "1. 必须是中国大陆身份证<br/>2. 距离有效期截至时间不大于 1 个月<br/>3. 证件清晰，图片上传不能倒置"
};

const BUSINESS_LICENSE_INDIVIDUAL = {
  title: "个体工商营业职照",
  des: "1、个体户执照需要上传原件<br />2、属于入驻人的个体户执照<br />3、公司类型为个体户性质<br />4、距离有效期截至时间应大于1个月<br />5、证件清晰"
};

const BUSINESS_LICENSE_ENTERPRISE = {
  title: "企业三证",
  des: "1、在中华人民共和国工商局注册的营业执照<br />2、确保申请入驻的企业不在《经营异常名录》中且所销售的商品在其经营范围内<br />3、距离有效期截止时间应大于 1 个月<br />4、证件清晰，图片不要倒置"
};

const LEGAL_PERSON_ID_CARD = {
  title: "法人身份证人像面照片<br/>法人身份证国徽面照片",
  des: "1、大陆身份证件、港澳台以及海外身份证件皆可<br/>2、距离有效期截止时间应大于1个月<br />3、证件清晰，图片上传不要倒置"
};

const TRADEMARK_REGISTRATION = {
  title: "商标注册证",
  des: "1、已经注册的商标（R 状态）或正在受理注册中的商标（TM 状态，注册申请时间必须满6个月）<br />2、距离截止时间要大于1个月<br />3、证件清晰，图片上传不要倒置"
};

const EXCLUSIVE_AUTHORIZATION = {
  title: "一级独占授权书",
  des: "1、若商标注册证或受理书上的注册人/申请人不是入驻主体，则需要提供一级独占授权书<br />2、若商标注册证或受理书上的注册人/申请人是入驻主体，则不需要提供授权书"
};

const STANDARD_AUTHORIZATION = {
  title: "授权书",
  des: "1、若商标注册证或受理书上的注册人/申请人不是入驻主体，则需要提供授权书，且授权级别需在2级以内<br />2、若商标注册证或受理书上的注册人/申请人是入驻主体，则不需要提供授权书"
};

const DOMESTIC_CLASS_35_TRADEMARK = {
  title: "境内35类商标注册证",
  des: "1、注册成功或申请时间距今满6个月但不超过2年<br />2、境内35类商标持有人为开店公司时，只需上传商标注册证明<br />3、境内35类商标持有人非开店公司时，需上传商标注册证明+商标持有人给开店公司的一级独占授权书"
};

const DOMESTIC_TRADEMARK = {
  title: "境内商标注册证",
  des: "中国大陆注册，注册成功或申请时间距今满6个月但不超过2年"
};

const OVERSEAS_TRADEMARK = {
  title: "境外同品牌商标注册证",
  des: "1、境外注册，注册成功或申请时间距今满6个月但不超过2年<br />2、若无商标注册证，可出具商标详细信息截图"
};

const RELATIONSHIP_PROOF = {
  title: "关系证明",
  des: "关系证明只接受\"关联关系证明\"和\"总代授权书\"（境外商标持有人委托境内商标持有人为总代理的文件）<br />① 境内商标持有人和境外商标持有人一致时，无需上传<br/>② 境内商标持有人和境外商标持有人不一致，需上传"
};

const TRADEMARK_HOLDER_IDENTITY = {
  title: "品牌方商标持有人身份证明复印件",
  des: "1、当授权商标持有人为自然人且非开店公司法定代表人时需出具<br />2、此时商标注册人类型选择\"自然人\"，授权书需商标持有人签字<br />3、身份证明复印件需带有本人签字"
};

const CUSTOMS_DECLARATION = {
  title: "报关单",
  des: "1、若为自有商标，报关单的境内收货人或消费使用单位需为商标持有人、总代理公司或开店公司<br />2、若为授权商标，报关单的境内收货人或消费使用单位需为授权链路中涉及的公司"
};

// 授权链路模板函数
const createAuthorizationChain = (level) => ({
  title: `境内/境外商标持有人到开店${level ? `<br />公司的完整授权链路（${level}以内）` : '公司的完整授权链路'}`,
  des: "1、授权链路需完整，且授权书在有效期内<br />2、完整的授权链路是指，例如境外商标持有人为A，一级经销商为B，开店公司为C，A授权给B是一级授权，B再授权给C是二级授权。则开店公司C需提供A到B和B到C的授权书，即A-B-C完整的2级授权链路"
});

// 店铺类型列表
const typeList1 = [
  {
    id: 1,
    name: "个人店",
    des: "适合个人/个体工商店户入驻，提供身份证等即可开店",
  },
  {
    id: 2,
    name: "企业店",
    des: "适合公司/企业开店，提供营业执照等资料即可开店",
  }
];

// 入驻类型列表
const enterTypeList1 = [
  { id: 1, name: "普通入驻" },
  { id: 2, name: "一般贸易" }
];

// 店铺子类型列表
const storeTypeList1 = [
  // { id: 1, name: "个人店" },
  { id: 2, name: "个体工商户" }
];

const storeTypeList2 = [
  { id: 3, name: "普通企业店" },
  { id: 5, name: "旗舰店" },
  { id: 6, name: "专卖店" },
  { id: 7, name: "专营店" }
];

const storeTypeList3 = [
  { id: 4, name: "卖场型旗舰店" },
  { id: 5, name: "旗舰店" },
  { id: 6, name: "专卖店" },
  { id: 7, name: "专营店" }
];

// 商品类型列表
const meritoTypeList1 = [{ id: 1, name: "普通商品" }];

const meritoTypeList2 = [
  { id: 2, name: "水果生鲜" },
  { id: 3, name: "美容个护" },
  { id: 4, name: "家居生活" },
  { id: 5, name: "服饰箱包" },
  { id: 6, name: "母婴玩具" },
  { id: 7, name: "食品保健" },
  { id: 8, name: "虚拟商品" },
  { id: 9, name: "运动户外" },
  { id: 10, name: "数码电器" },
  { id: 11, name: "家具家纺" },
  { id: 12, name: "医药健康" },
  { id: 13, name: "汽配摩托" }
];

// 表格数据 - 使用基础数据块组合
const tableDataOne1 = [ID_CARD_REQUIREMENT];

const tableDataOne2 = [
  ID_CARD_REQUIREMENT,
  BUSINESS_LICENSE_INDIVIDUAL
];

const tableDataOne3 = [
  ID_CARD_REQUIREMENT,
  LEGAL_PERSON_ID_CARD,
  BUSINESS_LICENSE_ENTERPRISE
];

const tableDataTwo1 = [
  TRADEMARK_REGISTRATION,
  EXCLUSIVE_AUTHORIZATION
];

const tableDataTwo2 = [
  TRADEMARK_REGISTRATION,
  STANDARD_AUTHORIZATION
];

const tableDataTwo3 = [
  DOMESTIC_CLASS_35_TRADEMARK,
  DOMESTIC_TRADEMARK,
  OVERSEAS_TRADEMARK,
  RELATIONSHIP_PROOF,
  createAuthorizationChain(),
  TRADEMARK_HOLDER_IDENTITY,
  CUSTOMS_DECLARATION
];

const tableDataTwo4 = [
  DOMESTIC_TRADEMARK,
  OVERSEAS_TRADEMARK,
  RELATIONSHIP_PROOF,
  EXCLUSIVE_AUTHORIZATION,
  TRADEMARK_HOLDER_IDENTITY,
  CUSTOMS_DECLARATION
];

const tableDataTwo5 = [
  DOMESTIC_TRADEMARK,
  OVERSEAS_TRADEMARK,
  RELATIONSHIP_PROOF,
  createAuthorizationChain("2级"),
  TRADEMARK_HOLDER_IDENTITY,
  CUSTOMS_DECLARATION
];

const tableDataTwo6 = [
  DOMESTIC_TRADEMARK,
  OVERSEAS_TRADEMARK,
  RELATIONSHIP_PROOF,
  createAuthorizationChain("4级"),
  TRADEMARK_HOLDER_IDENTITY,
  CUSTOMS_DECLARATION
];

const tableDataThree1 = [
  {
    title: "① 需上传对应品牌商品在中华人民共和国海关报关的报关单+开店公司从上一级供应商进货的进货凭证。开店公司或上一级供货商需为报关单的收货人或消费使用单位<br />② 需上传对应品牌商品在中华人民共和国海关报关的报关单+开店公司从上一级供应商进货的增值税发票",
    des: "1、报关单需含有所经营品牌，报关时间应在1年之内<br />2、进货凭证需满足以下要求：进货凭证上需有进货时间、品牌名、供货方信息和进货方信息，且进货方要为开店公司，进货时间距今不超过21个月。进货凭证上请加盖供货公司公章或请供货公司负责人签字<br />3、若以采购链路入驻，需提供网上可查询到的报关单收货人或消费使用单位的联系方式"
  }
];

// 导出所有变量（保持原有导出接口）
export {
  typeList1,
  enterTypeList1,
  storeTypeList1,
  storeTypeList2,
  storeTypeList3,
  meritoTypeList1,
  meritoTypeList2,
  tableDataOne1,
  tableDataOne2,
  tableDataOne3,
  tableDataTwo1,
  tableDataTwo2,
  tableDataTwo3,
  tableDataTwo4,
  tableDataTwo5,
  tableDataTwo6,
  tableDataThree1
};